import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { typeList, delPayType } from "@/api/aymentsdk/aymentsdk";
import addPayType from "./components/addPayType";
export default {
  name: "paymentType",
  components: {
    addPayType: addPayType
  },
  data: function data() {
    return {
      tableData: [],
      addPayType: false,
      total: 0,
      page: 1,
      show: false,
      showing: false,
      form: {
        file: ""
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSource: function handleSource(id) {
      this.$refs.addPayType.init(id);
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delPayType({
                  id: id
                }).then(function (res) {
                  _this.getList();
                });

                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    getList: function getList() {
      var _this2 = this;

      var page = {
        page: this.page
      };
      typeList(page).then(function (res) {
        _this2.tableData = res.data.data;
        _this2.total = res.data.total;
        _this2.show = true;
      });
    }
  }
};